import Image from '@atoms/Image/Image';
import Text from '@atoms/Text/Text';
import { IImage } from '@models/IImage';

export interface IContactCards {
  readonly title: string;
  readonly mobileLabel: string;
  readonly cards: IContactCard[];
}

interface IContactCard {
  readonly image: IImage;
  readonly name: string;
  readonly role: string;
  readonly mobileLabel: string;
  readonly mobileNumber?: string;
  readonly email?: string;
}
const ContactCard = ({
  image,
  name,
  role,
  mobileLabel,
  mobileNumber,
  email,
}: IContactCard) => (
  <div className="tw-flex tw-gap-4 tw-bg-grey-10 tw-p-4 md:tw-gap-6 md:tw-p-6">
    <Image
      image={image}
      aspectRatio={1}
      width={80}
      classes="tw-w-[58px] md:tw-w-20 tw-flex-shrink-0"
    />
    <div>
      <Text variant="ds-headline-3" className="tw-mb-1 tw-block tw-text-black">
        {name}
      </Text>
      <Text as="p" variant="label-12" className="tw-text-grey-70">
        {role}
      </Text>
      {(mobileNumber || email) && (
        <div className="tw-mt-2 tw-text-grey-80 md:tw-mt-4">
          {mobileNumber && (
            <Text as="p" variant="ds-paragraph">
              {mobileLabel}: {mobileNumber}
            </Text>
          )}
          {email && (
            <Text as="p" variant="ds-paragraph">
              {email}
            </Text>
          )}
        </div>
      )}
    </div>
  </div>
);

const ContactCards = ({ title, mobileLabel, cards }: IContactCards) => (
  <section className="tw-mb-20 tw-flex tw-flex-col tw-gap-4">
    <Text as="h2" variant="ds-quote" className="tw-text-black">
      {title}
    </Text>
    {cards.map((card) => (
      <div key={card.name}>
        <ContactCard {...card} mobileLabel={mobileLabel} />
      </div>
    ))}
  </section>
);

export default ContactCards;
